module.exports = __webpack_public_path__ + "img/bg1.cf888600.png";